export default {"src":"/_next/static/media/user-55x55.4a7d3d02.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};